import { createReducer } from 'typesafe-actions';
import { AutoExchangeState, RootAction } from './types';
import { AutoExchange as act } from './actionTypes';

// Typesafe InitialState!
export const initialState: AutoExchangeState = {
  emptyResults: false,
  loading: false,
};

export const autoExchangeReducer = createReducer<AutoExchangeState, RootAction>(
  initialState
).handleAction(act.LANDING_PAGE_INIT, (state) => ({
  ...state,
  loading: false,
}));
